import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faCheck,
  faTrophy,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import Button from "../shared/button/Button";
import companyPlacementHistoryType from "./types/companyPlacementHistoryType";
import companyEngagementHistoryType from "./types/companyEngagementHistoryType";
import {
  Backdrop,
  ModalWrapper,
  Title,
  TitleText,
  Tooltip,
  CloseButton,
  Engagements,
  Placements,
  MobileTitle,
  Body,
  ListItem,
  ListItemText,
  ButtonsWrapper,
  PlacementsPlaceholder,
  PlaceholderText,
} from "./styles/engagements-placements-modal-styles";

export const EngagementsPlacementsModal = ({
  companyEngagementHistory,
  companyPlacementHistory,
  toggleEngagementsPlacementsModal,
  placementsLength,
}) => (
  <Backdrop className="animated fadeIn">
    <ModalWrapper className="animated delay-1 fadeInDown">
      <Title>
        <TitleText>Company Engagement and Placement History</TitleText>
        <Tooltip
          data-tip="Recent engagements on the <strong>left</strong>,<br>recent placements on the <strong>right</strong>"
          data-for="eng-plac-tooltip"
        >
          <FontAwesomeIcon icon={faInfoCircle} />
        </Tooltip>
        <ReactTooltip
          html
          place="bottom"
          type="dark"
          effect="solid"
          aria-haspopup="true"
          id="eng-plac-tooltip"
        />
        <CloseButton onClick={() => toggleEngagementsPlacementsModal()}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </Title>
      <Body>
        <Engagements>
          <MobileTitle>engagements:</MobileTitle>
          {companyEngagementHistory.map((engagement) => (
            <ListItem key={engagement.id}>
              <FontAwesomeIcon icon={faCheck} />
              <ListItemText>{engagement.job.title}</ListItemText>
            </ListItem>
          ))}
        </Engagements>
        <Placements>
          {placementsLength < 1 && (
            <PlacementsPlaceholder>
              <PlaceholderText placements>
                We’re working on getting our first Hiring Hub placement!
              </PlaceholderText>
            </PlacementsPlaceholder>
          )}
          {placementsLength > 0 && <MobileTitle>placements:</MobileTitle>}
          {companyPlacementHistory.map((placement) => (
            <ListItem key={placement.id} data-test-id="placement-list-item">
              <FontAwesomeIcon icon={faTrophy} />
              <ListItemText>{placement.job.title}</ListItemText>
            </ListItem>
          ))}
        </Placements>
      </Body>
      <ButtonsWrapper>
        <Button
          primary
          buttonName="Close"
          onClickAction={() => toggleEngagementsPlacementsModal()}
        />
      </ButtonsWrapper>
    </ModalWrapper>
  </Backdrop>
);

EngagementsPlacementsModal.propTypes = {
  companyEngagementHistory: companyEngagementHistoryType.isRequired,
  companyPlacementHistory: companyPlacementHistoryType.isRequired,
  toggleEngagementsPlacementsModal: PropTypes.func.isRequired,
  placementsLength: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  companyEngagementHistory:
    state.agencyProfile.profileData.companyEngagementHistory,
  companyPlacementHistory:
    state.agencyProfile.profileData.companyPlacementHistory,
  placementsLength:
    state.agencyProfile.profileData.companyPlacementHistory.length,
});

export default connect(mapStateToProps, {})(EngagementsPlacementsModal);
